import { walkthrough } from '@/types/walkthrough';
import { Tour } from 'nextstepjs';

export const steps: Tour[] = [
  {
    tour: walkthrough.DASHBOARD,
    steps: [
      {
        icon: '👋',
        title: 'Bienvenue sur le nouveau tableau de bord',
        content:
          'Nous avons amélioré plusieurs éléments pour rendre la navigation plus claire et plus intuitive. Voici les nouveautés !',
        side: 'top',
        showControls: true,
        showSkip: true,
      },

      {
        icon: '✨',
        pointerRadius: 1,
        pointerPadding: 1,
        title: 'Nouveau système d’affichage des seuills',
        content:
          'Le vieux bouton « afficher les seuils » a été supprimé. Pour voir les seuills maximum ou minimum, il suffit maintenant de cliquer directement sur "seuil maximale" ou "seuil minimale".',
        selector: '#peak-controls',
        side: 'right',
        showControls: true,
        showSkip: true,
      },

      {
        icon: '📈',
        pointerRadius: 1,
        pointerPadding: 1,
        title: 'Affichage des seuils maximum',
        content: 'Un clic sur "seuil maximale" affiche uniquement les seuils maximum. C’est plus clair et plus visuel.',
        selector: '#peak-max-button',
        side: 'top',

        showControls: true,
        showSkip: true,
      },
      {
        icon: '📉',
        pointerRadius: 1,
        pointerPadding: 1,
        title: 'Affichage des seuils minimum',
        content: 'Un clic sur "seuil minimale" affiche uniquement les minimums. C’est plus clair et plus visuel.',
        selector: '#peak-min-button',
        side: 'top',
        showControls: true,
        showSkip: true,
      },

      {
        icon: '📦',
        pointerRadius: 5,
        pointerPadding: 7,
        title: 'Nouveaux encadrés autour des graphiques',
        content:
          'Chaque graphique est maintenant placé dans une carte dédiée afin de rendre la lecture plus propre et plus structurée.',
        selector: '#chart-card-1',
        side: 'top',
        showControls: true,
        showSkip: true,
      },

      {
        icon: '📅',
        pointerRadius: 1,
        pointerPadding: 3,
        title: 'Date picker indépendant',
        content:
          'Chaque graphique possède désormais son propre filtre de dates pour vous permettre d’analyser des périodes différentes selon vos besoins.',
        selector: '#date-picker',
        side: 'left',
        showControls: true,
        showSkip: true,
      },

      {
        icon: '📊',
        pointerRadius: 1,
        pointerPadding: 3,
        title: 'Sélecteur de type de graphique par graphique',
        content:
          'Vous pouvez maintenant choisir un type de graphique différent pour chaque carte : Line, Area, Bar… C’est beaucoup plus flexible !',
        selector: '#chart-type-selector-1',
        side: 'left',
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🚀',
        pointerRadius: 1,
        title: 'C’est parti !',
        content: 'Votre tableau de bord est maintenant beaucoup plus modulable. Explorez les nouvelles options !',
        side: 'left',
        showControls: true,
        showSkip: true,
      },
    ],
  },
];
